<template>
  <div class="sector product-sector py-0">
    <div class="row">
      <!-- header -->
      <div class="col-12 pb-2">
        <div class="product-sector__header">
          <div class="product-sector__text flex justify-content-between align-items-end">
            <span class="text-accent" style="font-weight: 600; font-size: 110%; ">
              {{ $t("carts.groupDetail") }}
            </span>
            <span class="ml-2 text-base text-gray-500">
              {{ $t("carts.currentlySelected") }}
              <span class="text-accent h6">{{ cartCount }}</span>
              {{ $t("carts.items", cartCount) }}
            </span>
          </div>
        </div>
      </div>

      <div class="product-sector__content col-12 py-0 px-1 open">
        <div v-for="(g, gk) in cartEventGroupsFormatted" :key="gk">
          <!-- group header -->
          <div class="product-sector__group-title">
            {{ g.cart_group_name }}
          </div>
          <div class="col-12" style="padding: 0 0 5px;">
            <!-- productItem -->
            <div v-for="n in g.items" :key="n.cart_id" class="product-group relative">
              <CartNotAvailable :cart="n" :state="state" :data="data" :form="form" :is-cart-editing="state.isCartEditing"
                @update="(val) => handleCartNotAvailableUpdate(n, val)" />
              <div class="product-group__content flex gap-2 justify-content-center align-items-center px-1">
                <div class="product-item__checkbox">
                  <el-checkbox v-model="n.checked" :disabled="!n.is_valid" size="large" class="px-1"
                    @change="(val) => handleChange(val, n.cart_id)">
                  </el-checkbox>
                </div>
                <div class="product-group__content flex-1 text-left">
                  <div class="flex justify-between gap-2">
                    <div class="product-item__name-main mt-1 text-base font-weight-medium">
                      <div v-if="n?.label" class="badge badge-pill badge-accent assort-label text-left mt-2">
                        {{ n.label }}
                      </div>
                      <div>{{ n.product_name }}</div>
                    </div>
                  </div>
                  <!-- 選擇組合assort & 數量quantity -->
                  <div class="product-item__name-sub text-gray-500 mb-1 text-sm" style="margin-top: -4px;">
                    <!-- <span>{{ n.assort_name }}</span> -->
                    <!-- 數量 -->
                    <!-- <span class="product-item__qty text-lg text-accent font-weight-bolder">
                      x {{ n.quantity }}
                    </span> -->
                    
                    <div class="mt-1 flex gap-2 justify-content-start align-items-start">
                      <!-- <span class="text-base">{{ n.assort_name }}</span> -->
                      <cart-assort-selector
                        :data="n"
                        :dealer="dealerData"
                        :is-subscribe="!!isSubscribe"
                        :store-data="storeData"
                        @change="handleChangeAssort"
                      />

                      <div class="w-16">
                        <cart-quantity-selector v-model="n.quantity" :min="n.min_order_quantity"
                          :max="Math.min(n.max_order_quantity, n.inventory)"
                          @change="(val) => changeQty(n.cart_id, val)" />
                      </div>
                    </div>
                  </div>
                  <!-- 活動贈品 -->
                  <div v-if="!!n?.gift_items?.length" class="product-item__name-gift">
                    <p class="text-primary font-weight-bold">{{ $t("贈品") }}:</p>
                    <ol>
                      <li v-for="(gift, gIndex) in n.gift_items" :key="gIndex">
                        {{ giftItemTypes[gift.type] }}
                        <span v-if="gift.type == 'plan'">
                          {{ gift?.plan?.name }}
                        </span>
                        <span v-else>
                          :
                          {{
                            gift.type == "shop_coin"
                            ? $n(gift?.shop_coin)
                            : $n(gift?.virtual_order_amount)
                          }}
                        </span>
                        <span class="text-muted">
                          (
                          {{ $t("於") }}
                          {{
                            gift.assign_time == "created_at"
                            ? $t("訂單成立後")
                            : $t("訂單出貨後")
                          }}
                          <span v-if="gift.type == 'shop_coin'">
                            {{
                              gift?.valid_after_day > 0
                              ? $n(gift?.valid_after_day)
                              : ""
                            }}
                            {{ $t("common.day") }}
                          </span>
                          {{ $t("生效") }}
                          )
                        </span>
                      </li>
                    </ol>
                  </div>
                </div>

                <!-- 金額 -->
                <div v-if="!hiddenPrice" class="product-item__total-price text-right">
                  <span style="font-size: 0.825rem;">
                    {{ aliasTranslations?.sale_price || $t("products.salePrice") }}
                  </span>
                  <span class="text-accent"
                    style="white-space: nowrap; font-size: 24px; font-weight: 600; display: block;">
                    {{ currencyFormat(n.sale_price * n.quantity) }}
                  </span>
                  <!-- 折扣金額 -->
                  <div v-if="n.discounted_price && n.sale_price > n.discounted_price">
                    <span style="font-size: 0.9rem;">
                      {{ $t("折扣") }}
                    </span>
                    <span style="white-space: nowrap; font-size: 1rem; font-weight: 500; margin-left:5px;">
                      {{ `(${currencyFormat((n.sale_price - n.discounted_price) * n.quantity)})` }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="g.choose_gifts.length > 0" class="col-12 pa-0">
            <ChooseGift :data="g.choose_gifts" :key-id="g.cart_group_key" :max-quantity="g.choose_gift_qty" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import { useVModels } from "@vueuse/core";
import { useI18n } from "vue-i18n"
import { breakpoint, currencyFormat, dataTranslations as dt, lookupAliasTranslations } from "../../../utils";
import {
  _api_createCart,
  _api_deleteCart,
  _api_updateCartQty,
  _api_createCartGroup,
} from "../../../api/index.js";
import ChooseGift from "./ChooseGift.vue";
import CartNotAvailable from "./CartNotAvailable.vue";
import CartQuantitySelector from "../../checkout/CartQuantitySelector.vue"
import CartAssortSelector from "../../checkout/CartAssortSelector.vue";

const props = defineProps({
  modelValue: Object,
  state: Object,
  data: Object,
  cartEventGroupsFormatted: Object,
});
const emit = defineEmits([
  "update:modelValue",
  "update:state",
  "update:data",
  "delete",
  "change",
  "change-assort",
]);

const {
  modelValue: form,
  state,
  data,
} = useVModels(props, emit);

const { t, n, locale } = useI18n()
const store = useStore();

const dealerData = computed(() => store.getters["lite/dealerData"]);
const isSubscribe = computed(() => store.getters["lite/isSubscribe"]);
const storeData = computed(() => store.getters["lite/storeData"]);

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)
const hiddenPrice = computed(() => !!storeData.value?.settings?.hidden_price)
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart)
const hiddenContact = computed(() => !!storeData.value?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(storeData.value?.alias_translations, locale.value))

const cartCount = computed(() =>
  form.value.carts.reduce(
    (count, cart) => (count += cart.checked ? cart.quantity : 0),
    0
  )
);

const giftItemTypes = computed(() => ({
  shop_coin: t("購物金"),
  virtual_order_amount: t("虛擬營業額"),
  plan: "", //方案
}));
const handleChangeAssort = async (item) => {
  emit("change-assort", item)
};
const deleteCart = (cartId) => {
  swal
    .fire({
      title: t("確認從購物車移除？"),
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dd3333",
      cancelButtonColor: "#78909C",
      confirmButtonText: t("確認移除"),
      cancelButtonText: t("按錯了!"),
    })
    .then((result) => {
      if (result.value) {
        emit("delete", cartId);
      }
    });
};

const changeQty = (cartId, qty) => {
  if (cartId) {
    if (qty > 0) {
      emit("change", { cartId, qty });
    } else {
      deleteCart(cartId);
    }
  }
};

const handleChange = (val, cart_id) => {
  const item = form.value.carts.find((el) => el.cart_id === cart_id);
  item.checked = val;
};

const handleCartNotAvailableUpdate = (cart, val) => {
  // console.warn("handleCartNotAvailableUpdate", cart, val);
  if (val === "remove") {
    deleteCart(cart.cart_id);
  } else if (val === "max-qty") {
    changeQty(cart.cart_id, cart.max_order_quantity);
  }
};
</script>

<style lang="scss">
.product-sector {

  .product-group {

    .cart-not-available~.product-group__content {
      opacity: 0.7;
    }

    .product-item__checkbox {
      .el-checkbox__inner {
        height: 20px !important;
        width: 20px !important;

        &::after {
          height: 12px !important;
          left: 7px !important;
        }
      }
    }
  }
}
</style>